import { useEffect } from "react";

const HOUR_IN_MS = 60 * 60 * 1000;

export const useInactivityReload = () => {
  useEffect(() => {
    const reloadInterval = setInterval(() => {
      window.location.reload();
    }, HOUR_IN_MS);

    return () => clearInterval(reloadInterval);
  }, []);
};
